// extracted by mini-css-extract-plugin
export default {"overlay":"OpportunitiesFormMenu_overlay__3nQGT","menu":"OpportunitiesFormMenu_menu__OMOs0"};